/*
|--------------------------------------------------------------------------
| Site Forms: Search Form
|--------------------------------------------------------------------------
*/
__gh__webApp.siteForms.searchForm = {

	/**
	 * Initialize search form
	 */
	"init": function(){
		this.bindEvents();
	},


	/**
	 * Bind the events for the search form
	 */
	"bindEvents": function(){
		var searchForm					= __gh__webApp.siteForms.searchForm,
	 		$siteSearchForm				= $("#toprail-search-form"),
	 		$searchIcon					= $('#toprail-search > .fa-search'),
	 		$siteSearchFormContainer	= $("#toprail-search");

	 	//Show hide search box
	 	$searchIcon.on('click', function() {
			$siteSearchForm.toggleClass("active");
			if($siteSearchForm.hasClass("active")){
				$siteSearchForm.find("input").focus();
			}
		});

		try{
			//Close searchbox if it's open and you click outside the container
		  	$siteSearchFormContainer.clickOff(function(element,event){
		  		searchForm.hideSearchBox();
		  	});

		}
		catch(e){}

	  	$(document).ready(function(){
		  //Submit search forms
		  var $anySiteSearchForm = $("form[name=siteSearchForm]"); //search page & top rail
			  $anySiteSearchForm.submit(function(event){
				  searchForm.submitForm({"event":event,"submittedSearchForm":this});
				  searchForm.hideSearchBox();
			  });
	  	});

	},


	/**
	 * Clear search text for other search forms on the page
	 */
	"clearOtherSearchBoxText": function(submittedSearchForm){
		var searchForm		= __gh__webApp.siteForms.searchForm,
			$siteSearchForm	= $("form[name=siteSearchForm]");
			$siteSearchForm.not(submittedSearchForm).find("input[name=\"searchText\"]").val("");
	},


	"hideSearchBox": function(){
		var $siteSearchForm = $("#toprail-search-form");
		$siteSearchForm.removeClass("active");
	},


	/**
	 * Submit the search form
	 */
	"submitForm": function(options){
		var event 				= (options.event) 				? options.event 				: null,
			submittedSearchForm	= (options.submittedSearchForm) ? options.submittedSearchForm 	: null,
			currentPage 		= __gh__webApp.currentPage,
			commonJS			= __gh__webApp.common,
			searchForm			= __gh__webApp.siteForms.searchForm,
			searchPage			= __gh__webApp.searchPage,
			$siteSearchForm		= $("form[name=siteSearchForm]"),
			searchText			= $(submittedSearchForm).find("input[name=\"searchText\"]").val().trim();
	
		event.preventDefault();
	
		// If no search text was supplied, don't do anything
		if (searchText == "") { return; }
	
		//Clear search box text from other search boxes on the page
		searchForm.clearOtherSearchBoxText(submittedSearchForm);
	
		//Use search page submit if on the search page
		/*
			if(currentPage.isSearch()) {
			searchPage.searchForm.submitSearchForm(searchText);
			return;
		}
		*/
	
		//Send to search page
		var hasQuotes 			= /(\%22|")(.*?)(\%22|")/g.exec(searchText),
			searchPageURL 		= "/search?text="+ searchText;
			searchPageURL		= (hasQuotes) ? searchPageURL + "&searchq=true" : searchPageURL;
			
		commonJS.goToURL(searchPageURL);
	
	}

};
